import { observable, action, makeObservable } from 'mobx'

const isPhoneDevice = () => (window.screen.width < 576 || window.screen.height < 576)

const isPortraitMode = () => {

  if (window.matchMedia) return window.matchMedia('(orientation: portrait)').matches

  // iOS Safari / iOS Chrome fallback
  const orientation = (window as any).orientation as number | undefined
  if (typeof orientation === 'number')  return orientation === 0 || orientation === 180

  // Android Chrome fallback
 if (window.screen.orientation) {
    return /portrait/i.test(window.screen.orientation.type)
  }

  // 最後備案
  return window.innerHeight >= window.innerWidth
}

class Store {
  @observable private _isPhone = isPhoneDevice()
  @observable private _isPortrait = isPortraitMode()
  
  private updateTimeout: number | null = null
  private orientationMQ: MediaQueryList
  private handler: () => void

  constructor() { 
    makeObservable(this)

    this.handler = () => {
      if (this.updateTimeout) clearTimeout(this.updateTimeout)
      this.updateTimeout = window.setTimeout(() => this.detectDevice(), 50)
    }

    window.addEventListener('resize', this.handler)
    window.addEventListener('orientationchange', this.handler)

    this.orientationMQ = window.matchMedia('(orientation: portrait)')
    this.orientationMQ.addEventListener('change', this.handler)
  }

  get isPhone() { return this._isPhone }
  get isPortrait() { return this._isPortrait }

  get width() {
    const { innerWidth, innerHeight } = window
    if (this.isPortrait) return innerWidth < innerHeight ? innerWidth : innerHeight
    else return innerWidth > innerHeight ? innerWidth : innerHeight

}

  get height() {
    const { innerWidth, innerHeight } = window
    if (this.isPortrait) return innerHeight > innerWidth ? innerHeight : innerWidth
    else return innerHeight < innerWidth ? innerHeight : innerWidth
}

  get orientationType() {
    return window.screen.orientation?.type || 'unknown'
  }

  @action detectDevice = () => {
    const newIsPhone = isPhoneDevice()
    const newIsPortrait = isPortraitMode()

    if (this._isPhone !== newIsPhone || this._isPortrait !== newIsPortrait) {
      this._isPhone = newIsPhone
      this._isPortrait = newIsPortrait
    }
  }

  destroy() {
    if (this.updateTimeout) clearTimeout(this.updateTimeout)
    window.removeEventListener('resize', this.handler)
    window.removeEventListener('orientationchange', this.handler)
    this.orientationMQ.removeEventListener('change', this.handler)
  }
}

export const deviceStore = new Store()